module.exports = "/../../dist/frontend/images/agency-pin-some-pro.png?b164203e00249c32ba969f2967464bde";